import { GalleryItem } from '../types';
import { CLIENT_IMAGES } from './restaurantData';

export const DEFAULT_GALLERY_ITEMS: GalleryItem[] = [
  // 0. Prestigious Awards
  {
    id: 'g-award-2024',
    src: '/2024 Award.jpeg',
    fallbackSrc: '/2024-award.jpeg',
    title: '2024 Extra Mile Award Winner — 1066 Business Awards',
    category: 'kiosk-team',
    desc: 'Frankie and team receiving the 2024 Extra Mile Award on stage, celebrating outstanding dedication to customer care and hospitality at Ramsgate Beach.',
  },

  // 1. Kiosk & Team
  {
    id: 'g-team',
    src: CLIENT_IMAGES.barSelfie,
    fallbackSrc: CLIENT_IMAGES.barSelfie,
    title: "Frankie's Beach Bar Team & Warm Hospitality",
    category: 'kiosk-team',
    desc: "Authentic smiles, cold drinks, iced slushies and welcoming coastal service inside Frankie's bar with Maggie, Frankie and the crew.",
  },
  {
    id: 'g-terrace',
    src: CLIENT_IMAGES.kioskExterior,
    fallbackSrc: CLIENT_IMAGES.kioskExterior,
    title: "Frankie's Beachfront Grounds & Ramsgate Carousel",
    category: 'kiosk-team',
    desc: "Outdoor beach dining area, seaside seating, Ramsgate sand, and the family fun carousel right beside Frankie's.",
  },

  // 2. Burgers & Hot Dogs
  {
    id: 'g-burger-beef',
    src: '/dishes/Beef Burger.png',
    fallbackSrc: '/dishes/Beef Burger.png',
    title: '6oz Beef Burger',
    category: 'burgers-dogs',
    desc: 'A 6oz juicy beef patty served in a brioche bun. Why not add salad, grilled onions and a sauce!',
  },
  {
    id: 'g-burger-bacon-cheese',
    src: '/dishes/Bacon Cheese Burger.png',
    fallbackSrc: '/dishes/Bacon Cheese Burger.png',
    title: 'Bacon Cheese Burger',
    category: 'burgers-dogs',
    desc: 'A juicy 6oz patty loaded with mature cheddar and thick danish bacon. Served, if you would like, on a bed of lettuce and tomato with onions in a brioche bun. We have lots of sauces to choose from too!',
  },
  {
    id: 'g-burger-chilli-cheese',
    src: '/dishes/Caribbean Chilli Cheese Burger.png',
    fallbackSrc: '/dishes/Caribbean Chilli Cheese Burger.png',
    title: 'Caribbean Chilli Cheese Burger',
    category: 'burgers-dogs',
    desc: 'A juicy 6oz patty loaded with mature cheddar and an American slice! Served, if you would like, on a bed of lettuce & tomato and grilled onions in a brioche bun. Topped off with our delicious Caribbean pepper sauce',
  },
  {
    id: 'g-burger-double-egg',
    src: '/dishes/Double Egg Cheese Burger.png',
    fallbackSrc: '/dishes/Double Egg Cheese Burger.png',
    title: 'Double Egg Cheese Burger',
    category: 'burgers-dogs',
    desc: 'A juicy 6oz patty loaded with mature cheddar and two large free range eggs. Served, if you would like, on a bed of lettuce & tomato and grilled onions in a brioche bun. We have lots of sauces to choose from too!',
  },
  {
    id: 'g-burger-stilton',
    src: '/dishes/Stilton Cheese Bacon Burger.png',
    fallbackSrc: '/dishes/Stilton Cheese Bacon Burger.png',
    title: 'Stilton Cheese Bacon Burger',
    category: 'burgers-dogs',
    desc: 'A juicy 6oz patty topped with melted Stilton and thick Danish bacon. Served, if you would like, on a bed of lettuce & tomato and grilled onions in a brioche bun. We have lots of sauces to choose from too!',
  },
  {
    id: 'g-burger-veggie',
    src: '/dishes/Supreme Veggie Burger.png',
    fallbackSrc: '/dishes/Supreme Veggie Burger.png',
    title: 'Supreme Veggie Burger',
    category: 'burgers-dogs',
    desc: 'A delicious alternative for vegetarians. We serve our burger on a brioche bun. Why not add lettuce, tomato and grilled onions to complete! We have a large range of sauces too for you.',
  },
  {
    id: 'g-burger-chicken-cheese',
    src: '/dishes/Chicken Cheese Burger.png',
    fallbackSrc: '/dishes/Chicken Cheese Burger.png',
    title: 'Chicken Burger',
    category: 'burgers-dogs',
    desc: 'A large butter milk chicken fillet served in a brioche bun! Why not add lettuce, tomato and grilled onions to make it that bit more special! There are lots of sauces to choose from aswell',
  },
  {
    id: 'g-burger-chicken-jack',
    src: '/dishes/Chicken Jack Burger.png',
    fallbackSrc: '/dishes/Chicken Jack Burger.png',
    title: 'Chicken Cheese jack Burger',
    category: 'burgers-dogs',
    desc: 'A large butter milk chicken fillet served in a brioche bun with the famous Jack Daniels sauce and melted mature cheddar! Why not add lettuce, tomato and grilled onions to make it that bit more special! There are lots of sauces to choose from aswell',
  },
  {
    id: 'g-burger-venison',
    src: '/dishes/Venison Burger.png',
    fallbackSrc: '/dishes/Venison Burger.png',
    title: 'Venison Burger',
    category: 'burgers-dogs',
    desc: '2 juicy venison patties loaded with mature cheddar. Served on a bed of lettuce and tomato in a brioche bun. Locally sourced meat make it a firm favourite of ours !',
  },
  {
    id: 'g-dog-frankfurter',
    src: '/dishes/The Footlong Frankfurter.png',
    fallbackSrc: '/dishes/The Footlong Frankfurter.png',
    title: 'The Footlong Frankfurter',
    category: 'burgers-dogs',
    desc: 'A delicious classic Frankfurter hotdog with a smoky flavour served in a soft brioche bun.',
  },
  {
    id: 'g-dog-lincolnshire',
    src: '/dishes/The Lincolnshire Long Dog.png',
    fallbackSrc: '/dishes/The Lincolnshire Long Dog.png',
    title: 'The Lincolnshire Long Dog',
    category: 'burgers-dogs',
    desc: 'A British banger filled with a blend of herbs and spices, served in a soft brioche bun.',
  },

  // 3. Crispy French Fries
  {
    id: 'g-cheesy-fries',
    src: '/dishes/cheesy-fries.png',
    fallbackSrc: '/dishes/cheesy-fries.png',
    title: 'Cheesy Fries',
    category: 'loaded-fries',
    desc: 'Fries with mature cheddar cheese torched to perfection.',
  },
  {
    id: 'g-pepperoni-fries',
    src: '/dishes/pepperoni-cheese-loaded-fries.png',
    fallbackSrc: '/dishes/pepperoni-cheese-loaded-fries.png',
    title: 'Pepperoni & Cheese Loaded Fries',
    category: 'loaded-fries',
    desc: 'Pepperoni and our mature cheddars torched to perfection over our fries.',
  },
  {
    id: 'g-chicken-fries',
    src: '/dishes/southern-fried-chicken-cheese-loaded-fries.png',
    fallbackSrc: '/dishes/southern-fried-chicken-cheese-loaded-fries.png',
    title: 'Southern Fried Chicken & Cheese Loaded Fries',
    category: 'loaded-fries',
    desc: 'Southern fried chicken and our mature cheddars torched to perfection over our fries.',
  },
  {
    id: 'g-fish-fingers-fries',
    src: '/dishes/fish-fingers-cheese-loaded-fries.png',
    fallbackSrc: '/dishes/fish-fingers-cheese-loaded-fries.png',
    title: 'Fish Fingers & Cheese Loaded Fries',
    category: 'loaded-fries',
    desc: 'Fish fingers and our mature cheddars torched to perfection over our fries.',
  },

  // 4. Beach Rides & Family Fun
  {
    id: 'g-childern-1',
    src: CLIENT_IMAGES.childrenSlide,
    fallbackSrc: CLIENT_IMAGES.childrenSlide,
    title: 'Giant 3-Lane Inflatable Beach Slide',
    category: 'family',
    desc: 'Vibrant green, yellow, and blue inflatable climbing slide towering right on the Ramsgate beach sand.',
  },
  {
    id: 'g-childern-2',
    src: CLIENT_IMAGES.childrenKiddiesCorner,
    fallbackSrc: CLIENT_IMAGES.childrenKiddiesCorner,
    title: 'Kiddies Corner Carousel & Family Beach Fun',
    category: 'family',
    desc: 'Families enjoying the seaside carousel and amusements right beside Frankie’s beach dining tables.',
  },
  {
    id: 'g-childern-3',
    src: CLIENT_IMAGES.childrenTrampolines,
    fallbackSrc: CLIENT_IMAGES.childrenTrampolines,
    title: 'Beachfront Trampolines Arena on Ramsgate Sands',
    category: 'family',
    desc: 'Multi-bed trampoline jumping arena with striped valance skirting, safety nets, and ocean breezes.',
  },
  {
    id: 'g-childern-4',
    src: CLIENT_IMAGES.childrenCarousel,
    fallbackSrc: CLIENT_IMAGES.childrenCarousel,
    title: 'Vintage Red & Yellow Carousel on Ramsgate Sands',
    category: 'family',
    desc: 'Traditional scalloped merry-go-round with white picket fencing right beside the calm blue sea.',
  },

  // 6. Frankie's Beach Hire & Sun Lounges
  {
    id: 'g-sun-lounges',
    title: 'Sun Lounges at Frankie’s',
    src: '/sun-lounges.webp',
    fallbackSrc: '/Sun Lounges.jpeg',
    category: 'family',
    desc: 'Comfortable seaside sun loungers available for daily hire right on Ramsgate sands from Frankie’s Kiosk 1.',
  },

  // 7. Promenade Seating Video
  {
    id: 'g-promenade-seating',
    title: 'Promenade Seating Video',
    src: '/promenade-seating-poster.webp',
    fallbackSrc: '/promenade-seating-poster.jpg',
    videoSrc: '/promenade-seating.mp4',
    fallbackVideoSrc: '/PROMENADE SEATING.mp4',
    poster: '/promenade-seating-poster.webp',
    isVideo: true,
    category: 'family',
    desc: 'Take in the fresh sea breeze from Frankie’s promenade terrace seating right on Marina Esplanade overlooking Ramsgate Main Sands and the Royal Harbour.',
  },

  // 8. Ramsgate Main Sands Photography
  {
    id: 'g-ramsgate-sand',
    title: 'Ramsgate Main Sands Beachfront',
    src: '/ramsgate-sand.webp',
    fallbackSrc: '/ramsgate sand.jpeg',
    category: 'family',
    desc: 'Panoramic view of Ramsgate Main Sands beachfront right on Marina Esplanade outside Frankie’s Kiosk 1.',
  },
  {
    id: 'g-ramsgate-sand-2',
    title: 'Ramsgate Sand Sunny Beach',
    src: '/ramsgate-sand-2.webp',
    fallbackSrc: '/ramsgate sand 2.jpeg',
    category: 'family',
    desc: 'Golden sands, blue skies, and seaside visitors soaking in the Ramsgate coastline.',
  },
  {
    id: 'g-ramsgate-sand-3',
    title: 'Ramsgate Sand Coastal Esplanade',
    src: '/ramsgate-sand-3.webp',
    fallbackSrc: '/ramsgate sand 3.jpeg',
    category: 'family',
    desc: 'Scenic coastal vista along Marina Esplanade and Ramsgate beach promenade.',
  },
  {
    id: 'g-ramsgate-sand-4',
    title: 'Ramsgate Sand Shoreline & Beach',
    src: '/ramsgate-sand-4.webp',
    fallbackSrc: '/ramsgate sand 4.jpeg',
    category: 'family',
    desc: 'Golden sands and refreshing coastal shoreline along Ramsgate Main Sands.',
  },
];
